import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const HIDDEN_PATHS = [/^\/admin/, /^\/chat\//, /^\/messages$/];

// Shows/hides the Tawk.to bubble (loaded once from index.html) per route and cart state.
export const TawkVisibility = () => {
  const { pathname } = useLocation();
  const { isCartOpen } = useCart();
  const hidden = isCartOpen || HIDDEN_PATHS.some((re) => re.test(pathname));

  useEffect(() => {
    window.__rcmTawkSync = () => {
      const api = window.Tawk_API;
      if (!api || typeof api.hideWidget !== 'function') return;
      if (hidden) api.hideWidget(); else api.showWidget();
    };
    if (!hidden && window.__rcmLoadTawk) window.__rcmLoadTawk();
    window.__rcmTawkSync();
  }, [hidden]);

  return null;
};
